export default {
  validate: {
    empty: 'Dữ liệu trống',
    startWithAlphabet: 'Hãy bắt đầu nhập thông tin bằng chữ cái hoặc chữ số',
    onlyLatinWithSpecialCharacter:
      'Chỉ nhập ký tự Latin và những ký tự !@#$%^&*',
    limitCharacter: 'Số lượng ký tự tối đa là %{count}',
    startWithAlphabetOrNumber: 'Bắt đầu phải bằng chữ hoặc số',
  },
  delete_title: 'Xóa xác nhận',
  remove_message: 'Bạn có chắc muốn từ bỏ %{name}',
  remove_title: 'Từ bỏ %{name}',
  remove_cw_message: 'Bạn có chắc muốn loại bỏ mã chứng quyền',
  remove_cw_title: 'Loại bỏ mã chứng quyền',
  invalid_name_title: 'Tên không phù hợp',
  invalid_name_message: 'Tên bạn nhập không phù hợp. Hãy thử nhập tên khác',
  server_error: 'Lỗi Máy Chủ',
  exceed_limit_title: 'Vượt giới hạn %{name}',
  exceed_limit_create_message:
    'Bạn không thể tạo nhiều hơn %{count} %{name}. Hãy thử lại',
  errorLimitWorkspace: {
    title: 'Giới hạn Workspace',
    content: 'Bạn không thể tạo nhiều hơn 10 workspace . Hãy thử lại.',
  },

  titleErrorCreateNewLayout: 'Giới hạn lưu biểu mẫu',
  invalid_name_workspace: 'Tên Workspace không phù hợp',
  server_error_modify_workspace: 'Lỗi máy chủ khi sửa tên workspace',

  errorLimitWatchList: {
    title: 'Vượt quá giới hạn',
    content: 'Bạn không thể thêm nhiều hơn 100 ticker trong một watchlist',
  },

  errorExitTickerInWatchList: {
    title: 'Ticker đã tồn tại',
    content: 'Ticker này đã tồn tại trong watchlist',
  },

  errorExistCWInWatchList: {
    title: 'Chứng quyền đã tồn tại',
    content: 'Chứng quyền này đã tồn tại trong watchlist',
  },
  cannotCompare: 'Không thể so sánh',
  cannotCompareMessage: 'Mã cổ phiếu này không thể so sánh. Vui lòng thử lại!',
  cannotAddTickerCompare: 'Không thể thêm mã cổ phiếu',
  cannotAddTickerCompareMessage:
    'Bạn chỉ có thể so sánh tối đa 5 mã cổ phiếu. Vui lòng thử lại!',
};
